import React, { useState, useEffect } from "react";
import {
  FaYoutube,
  FaFacebookF,
  // FaTwitter,
  FaHome,
  FaUserAlt,
} from "react-icons/fa";
import { BiLogoInstagramAlt, BiLogoWhatsapp } from "react-icons/bi";
import { MdEmail, MdOutlineArticle } from "react-icons/md";
import { FaMapMarkerAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const TopNavbar = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const formatDate = (date) => {
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  return (
    <div className="hidden md:flex justify-between bg-[#101828] py-2 px-10 items-center overflow-hidden">
      {/* Sliding Contact Info */}
      <div className="flex-1 overflow-hidden">
        <div className="animate-slide">
          <span className="text-white text-sm font-bold mr-8">
            +91-7809477683
          </span>
          <span className="text-white text-sm font-bold">
            bbsrservices@gmail.com
          </span>
        </div>
      </div>


      {/* Social Media + Time */}
      <span
        data-aos="fade-left"
        className="flex gap-4 items-center flex-col sm:flex-row"
      >
        <span className="flex gap-3 items-center">
          {/* Home */}
          <a
            href="/"
            title="Home"
            className="text-green-500 hover:scale-110 transition-transform"
          >
            <FaHome size={22} />
          </a>

          {/* About Us */}
          <a
            href="/about"
            title="About Us"
            className="text-blue-400 hover:scale-110 transition-transform"
          >
            <FaUserAlt size={22} />
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/917809477683"
            target="_blank"
            rel="noopener noreferrer"
            title="Chat on WhatsApp"
            className="text-green-400 hover:scale-110 transition-transform"
          >
            <BiLogoWhatsapp size={22} />
          </a>

          {/* YouTube */}
          <a
            href="https://www.youtube.com/@bbsrservices"
            target="_blank"
            rel="noopener noreferrer"
            title="YouTube"
            className="text-red-500 hover:scale-110 transition-transform"
          >
            <FaYoutube size={22} />
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/bbsrservices"
            target="_blank"
            rel="noopener noreferrer"
            title="Facebook"
            className="text-blue-500 hover:scale-110 transition-transform"
          >
            <FaFacebookF size={22} />
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/bbsrservices?igsh=MTA0bWFvdjJvNzF2ZQ=="
            target="_blank"
            rel="noopener noreferrer"
            title="Instagram"
            className="text-pink-500 hover:scale-110 transition-transform"
          >
            <BiLogoInstagramAlt size={22} />
          </a>

          {/* Gmail */}
          <a
            href="mailto:bbsrservices@gmail.com"
            title="Send Email"
            className="text-red-400 hover:scale-110 transition-transform"
          >
            <MdEmail size={22} />
          </a>

          {/* Google Maps */}
          <a
            href="https://maps.app.goo.gl/ZUBx7wQbCNi8nrDk6"
            target="_blank"
            rel="noopener noreferrer"
            title="Find us on Google Maps"
            className="text-green-500 hover:scale-110 transition-transform"
          >
            <FaMapMarkerAlt size={22} />
          </a>

          {/* Blog */}
          <a
            href="/blog-list"
            title="Read our Blog"
            className="text-blue-400 hover:scale-110 transition-transform"
          >
            <MdOutlineArticle size={22} />
          </a>

          {/* Twitter */}
          {/* <a
            href="https://twitter.com/bbsrservices"
            target="_blank"
            rel="noopener noreferrer"
            title="Twitter"
            className="text-sky-400 hover:scale-110 transition-transform"
          >
            <FaTwitter size={22} />
          </a> */}
        </span>

        {/* Live Time */}
        <span className="text-white text-sm md:text-md ml-2">
          | {formatDate(currentTime)}
        </span>
      </span>
    </div>
  );
};

export default TopNavbar;


